import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const DemurrageRuleList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingDemurrageRule', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation) 
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'DemurrageRule'}
            api='secondary'
            showTitle={true}
            title={'Demurrage Rules'} 
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/demurrageRuleCrud', 'Create', t('Add')+' '+t('DemurrageRule'), row)],
                ['Edit', (row) => newRoute('containerControl/demurrageRuleCrud', 'Edit', t('Edit')+' '+t('DemurrageRule'), row)],
                ['Copy', (row) => newRoute('containerControl/demurrageRuleCrud', 'Copy', t('Copy')+' '+t('DemurrageRule'), row)]
            ])}
        />
    )
}
